import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PinholeUploaderService {

    constructor(private httpClient: HttpClient) {

    }

    upload(installIdOrLogin: string, file: File, type: UploadType): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        return this.httpClient.post(`/rest/admin/upload/${type}/${installIdOrLogin}`, formData, {withCredentials: true});
    }
}

export enum UploadType {
    Round = "round",
    Snapshot = "snapshot"
}